import type { IndicatorDelta } from '@ederest/contracts';
import { DIRECTION_LABELS, formatIndicatorDelta } from './comparison-format.js';

const TONES: Record<IndicatorDelta['direction'], string> = {
  improved: 'positive',
  worsened: 'negative',
  unchanged: 'neutral',
};

/**
 * The movement of an indicator, read through its polarity: a falling abandon
 * rate is an improvement and shows green whatever its sign.
 */
export function DirectionChip({ delta }: { delta: IndicatorDelta }) {
  return (
    <span
      className={`badge badge--${TONES[delta.direction]}`}
      data-direction={delta.direction}
      title={DIRECTION_LABELS[delta.direction]}
    >
      {formatIndicatorDelta(delta)}
      {delta.direction === 'improved' && ' ✓'}
      {delta.direction === 'worsened' && ' !'}
    </span>
  );
}
